import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('flashiq_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/flashiq/verify`)
        .then(res => {
          setUser({ username: res.data.username, token });
        })
        .catch(() => {
          localStorage.removeItem('flashiq_token');
          delete axios.defaults.headers.common['Authorization'];
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/flashiq/login`, { username, password });
    const { token, username: user } = res.data;
    localStorage.setItem('flashiq_token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser({ username: user, token });
    return true;
  };

  const logout = () => {
    localStorage.removeItem('flashiq_token');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
